import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'bevvi-homelanding',
  templateUrl: './homelanding.component.html',
  styleUrls: ['./homelanding.component.scss']
})
export class HomelandingComponent implements OnInit {

  faqTitle = "Frequently Asked Questions";
  // bannerImage = "/assets/images/banner-img/home-banner.png"
  headingTitle = "Celebrations, Simplified."
  paragraphInfo = "From boardrooms to ballrooms, we're pouring simplicity into your events and gifting options."


  constructor() { }

  ngOnInit() {
  }

}
